import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import React from "react";
import { BaseProps, Field } from "./field";

type Props = BaseProps<string> & {
  options: ({ label: string; value: string } | string)[];
  row?: boolean;
};

export const Radiogroup: React.FC<Props> = (props) => {
  function onChange(event: React.ChangeEvent<HTMLInputElement>): void {
    if (props.onChange) {
      props.onChange(props.name, event.target.value);
    }
  }

  return (
    <Field
      label={props.label}
      required={props.required}
      error={props.error}
      disabled={props.disabled}
      size={props.size}
    >
      <RadioGroup
        name={props.name}
        value={props.value}
        onChange={onChange}
        row={props.row}
      >
        {props.options.map((option) => {
          if (typeof option === "string") {
            option = {
              value: option,
              label: option,
            };
          }

          return (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio size="small" color="primary" />}
              label={option.label}
            />
          );
        })}
      </RadioGroup>
    </Field>
  );
};
